import { useMemo } from "react"
import { Doughnut } from "react-chartjs-2"
import { TooltipModel, TooltipItem } from "chart.js"
import { fixedOptions } from "./donutOptions"
import * as styles from "./styles/SemiDonutStyles"
import { Box } from "../../Box"
import { Data } from "../types"

export type SemiDonutProps<TData, TLabel> = {
  data: Data<TData, TLabel>[]
  toolTipLabelFn?: (this: TooltipModel<"doughnut">, tooltipItem: TooltipItem<"doughnut">) => string[] | string
  toolTipTitleFn?: (this: TooltipModel<"doughnut">, tooltipItem: TooltipItem<"doughnut">[]) => string[] | string
  height?: number
  width?: number
}

export const SemiDonutComponent = <TData = number, TLabel = unknown>({
  data,
  toolTipLabelFn,
  toolTipTitleFn,
  height = 200,
  width = 400,
}: SemiDonutProps<TData, TLabel>) => {
  const chartData = useMemo(() => {
    const colors = data.map((it) => it.color)
    return {
      datasets: [
        {
          data: data.map((it) => it.value),
          backgroundColor: colors,
          hoverBackgroundColor: colors,
        },
      ],
    }
  }, [data])
  const options = useMemo(
    () => ({
      ...fixedOptions,
      plugins: {
        ...fixedOptions.plugins,
        tooltip: {
          ...fixedOptions.plugins?.tooltip,
          callbacks: {
            label: toolTipLabelFn,
            title: toolTipTitleFn,
          },
        },
      },
    }),
    [toolTipLabelFn, toolTipTitleFn]
  )

  return (
    <Box css={styles.root}>
      <Doughnut options={options} data={chartData} height={height} width={width} />
    </Box>
  )
}

SemiDonutComponent.defaultProps = {
  toolTipTitleFn: undefined,
  width: 400,
  height: 200,
  toolTipLabelFn: undefined,
}
